import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AllBuyerSettings, CompanySettings } from '../models/settings.model';
import { SettingsApi } from '../api/settings.api';

@Injectable({ providedIn: 'root' })
export class SettingsService {
  private readonly _api = inject(SettingsApi);

  public getAllBuyerSettings(): Observable<AllBuyerSettings> {
    return this._api.getAllBuyerSettings();
  }

  public getCompanySettings(companyId: number): Observable<CompanySettings> {
    return this._api.getCompanySettings(companyId);
  }
}
